import { filter, isNaN, isNumber, map, mean, round, toNumber } from 'lodash';

import { usePatientPageNavigate } from '@/Pages/SinglePatientDetails/PatientPageNavigation';

import { ReactComponent as PSFSIcon } from '../../../../assets/icons/timeline/psfsIcon.svg';
import useQuestionnairesService from '../../../../services/questionnairesService';
import type { IPatientQuestionnaire } from '../../../../services/questionnairesService/types';
import { patientTabsUrl } from '../../../SinglePatientDetails/types';
import { rangesProps } from '../RangesProps/PSFSRangesProps';

export default function usePSFSEvent(patientUuid: string) {
  const { PSFSQuestionnaires } = useQuestionnairesService(patientUuid);
  const { navigateToPatientPage } = usePatientPageNavigate();

  return map(PSFSQuestionnaires, ({ createdAt, questions }: IPatientQuestionnaire) => {
    const scoreValue = round(
      mean(
        filter(
          map(questions, (x) => toNumber(x.answerId)),
          isNumber,
        ),
      ),
    );
    return {
      name: isNumber(scoreValue) && !isNaN(scoreValue) ? `${scoreValue}/10` : 'No score',
      date: createdAt,
      icon: PSFSIcon,
      ctaText: 'View PSFS',
      circle: {
        color: rangesProps.find((x) => scoreValue >= x.min && scoreValue <= x.max)?.color ?? '',
      },
      cta() {
        navigateToPatientPage(`/patients/${patientUuid}/${patientTabsUrl.activityLog}`);
      },
    };
  });
}
